export default __webpack_public_path__ + "static/media/Africa_04.3e334db2.png";